import { Flex, Skeleton, Text } from '@pancakeswap/uikit'
import styled from 'styled-components'
import BigNumber from 'bignumber.js'
import Balance from 'components/Balance'
// import { getBalanceNumber } from 'utils/formatBalance'
// import { BIG_ZERO } from 'utils/bigNumber'
import BaseCell, { CellContent } from './BaseCell'
import { Box, IconButton, Tooltip } from '@mui/material'
import { useLocation } from 'react-router-dom'
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

interface TotalStakedCellProps {
  pool: any
}

const StyledCell = styled(BaseCell)`
  /* flex: 1 0 100px; */
  /* width:1300px; */
  /* justify-content: end; */
  ${({ theme }) => theme.mediaQueries.md} {
    flex: 1 0 80px;
    width:160px;
  }
`

const TotalStakedCell: React.FC<TotalStakedCellProps> = ({ pool }) => {

  const location = useLocation();
  const { sousId, stakingToken, totalStaked, vaultKey } = pool

  return (
    <StyledCell role="cell">
      {location.pathname === '/farm' ?

        <>
          <CellContent>
            <Box sx={{ width:{xs:"145px"} }}>
              <Text fontSize="12px" color='#00FED9' textAlign="left">
                Liquidity
              </Text>

              <Flex height="20px" alignItems="center">
                {/* <Balance fontSize="16px" value={225} decimals={0} unit={` ${stakingToken.symbol}`} /> */}
                <Balance
                  mt="4px"
                  // display="inline"
                  fontSize='16px'
                  color='white'
                  decimals={3}
                  prefix="$"
                  value={pool.liquidity}
                  // unit={` ${stakingToken.symbol}`}
                  unit={''}
                />
                <Tooltip title="Total value of the funds in this farm’s liquidity pool" sx={{ fontSize: '16px' }} arrow placement="top">
                  <IconButton>
                    <HelpOutlineRoundedIcon sx={{ color: '#00FED9', width: '22px', height: '22px', ml: 2, mt: 0.5 }} />
                  </IconButton>
                </Tooltip>

              </Flex>
            </Box>
          </CellContent>
        </>
        :
        <CellContent>
          {/* <Tsc sx={{display:"flex"}}> */}
          <Text fontSize="12px" color='#00FED9' textAlign="left">
            Total staked
          </Text>

          <Flex height="20px" alignItems="center">
            {/* <Balance fontSize="16px" value={225} decimals={0} unit={` ${stakingToken.symbol}`} /> */}
            <Balance
              mt="4px"
              // display="inline"
              fontSize='16px'
              color='white'
              decimals={0}
              prefix=""
              value={pool.totalStaked}
              // unit={` ${stakingToken.symbol}`}
              unit={` ${pool.name}`}
            />
          </Flex>
          {/* </Tsc> */}
        </CellContent>
      }
    </StyledCell>
  )
}

export default TotalStakedCell
